import React from 'react';
import { Booking } from '../components/Booking';
import { usePageTitle } from '../hooks/usePageTitle';
export function BookPage() {
  usePageTitle('Book Your Missed-Lead Audit | Viridia Analytics');
  return <Booking data-id="element-497" data-mp="1bugo2hgzcil1" />;
}